<template>
    <div class="row ml-0 mr-0 translated-text d-flex align-items-center">
        <div
            style="max-width: 90%; padding: 0px"
            class="col sc-message--text-content translated-text-content d-flex align-items-center"
            v-html="data.text"
        />
        <div
            style="max-width: 5%; padding: 0; margin-left: 2px; justify-content: center"
            class="col sc-message--text-content translated-text-content d-flex align-items-center"
        >
            <!--            <img alt="aws logo" class="mr-1" src="/static/img/aws.png" style="height: 9px" />-->
            <p class="m-0" style="color: var(--color9); font-size: 10px">
                <md-tooltip md-direction="top" style="color: var(--primary-sent-message-text); background: var(--primary_); font-size: 9px; border-radius: 8px">
                    {{ $t("message.translatedTextDescription", { from: getLabel(data.from), to: getLabel(data.to) }) }}
                </md-tooltip>
                <a-icon class="m-0" type="info-circle" />
            </p>
        </div>
        <div class="col sc-message--text-content translated-text-content d-flex align-items-center m-1 setting-icon">
            <slot> </slot>
        </div>
    </div>
</template>

<script>
import languages from "../../../language/languages.json";

export default {
    name: "TranslatedText",
    props: ["data"],
    data() {
        return {
            languages,
        };
    },
    methods: {
        getLabel(code) {
            let maybeLang = this.languages.find((x) => x.code === code);
            return !!maybeLang ? maybeLang.originalName : code;
        },
    },
};
</script>

<style lang="scss" scoped>
.translated-text-content {
    color: black !important;
    opacity: 0.7;
    font-size: 14px;
}

.translated-text-content[data-v-40db884e] {
    word-break: keep-all;
}

.setting-icon {
    padding: 5px;
    max-width: 5%;
    justify-content: end;
}

</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/TranslatedText.vue